<template>
  <vue-final-modal v-slot="{ close }">
    <div class="loginmodal">
      <div class="art" :class="level"><!-- agreeart warningart -->
        <span class="alert-kicker">MEGA NOTICE</span>
        <span class="img"></span>
        <p v-html="$t(code)"></p>
        <div class="btn">
          <template v-if="type == 'confirm'">
            <button class="yes" @click="$emit('confirm', 'yes', close)">{{$t('front.button.yes')}}</button>
            <button class="no" @click="$emit('confirm', 'no', close)">{{$t('front.button.no')}}</button>
          </template>

          <template v-if="type == 'check'">
            <button class="yes" @click="$emit('check', 'ok', close)">{{$t('front.button.confirm')}}</button>
          </template>
        </div>
        <button class="closeart" type="button" aria-label="알림 닫기" @click="onClose(close)"><img src="@/assets/img/icon_cancel.png" alt="" /></button>
      </div>
    </div>
  </vue-final-modal>

</template>

<script>

export default {
  name: 'Alert',
  props: {
    code: {
      type: String
    },
    type: {
      type: String
    },
    level: {
      type: String,
      default: 'warningart'
    }
  },
  data () {
    return {
      lang: 'ko',
      result: ''
    }
  },
  methods: {
    onClose (close) {
      close()
      // this.$emit('close', this.type, this.result)
    }
  }
}
</script>

<style scoped>
button{cursor:pointer}.loginmodal{display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:rgba(7,2,3,.82)!important;backdrop-filter:blur(7px)}.art{position:relative;box-sizing:border-box;width:380px;max-width:calc(100vw - 40px);margin:0;padding:38px 34px 30px;text-align:center;border:1px solid #70454b;border-radius:12px;background:radial-gradient(circle at 50% 0,rgba(132,49,61,.2),transparent 44%),#190b0e;box-shadow:0 24px 80px rgba(0,0,0,.62),inset 0 1px rgba(255,255,255,.025)}.art p{margin:18px 0 0;font-size:14px;font-weight:600;color:#f1e4d7;line-height:1.65;word-break:keep-all}.art .btn{display:flex;justify-content:center;gap:10px}.art .yes,.art .no{box-sizing:border-box;flex:1;max-width:150px;height:44px;margin-top:26px;border-radius:4px;font-size:13px;font-weight:700}.art .img{display:block;width:50px;height:50px;margin:0 auto;background-position:center!important;background-repeat:no-repeat!important;background-size:contain!important;filter:sepia(1) saturate(.8) brightness(1.5)}.agreeart .img{background-image:url('~@/assets/img/agreeart.svg')}.warningart .img{background-image:url('~@/assets/img/warningart.svg')}.agreeart .yes,.warningart .yes{border:1px solid #d9ae5d;color:#1a090b;background:linear-gradient(135deg,#dfbd72,#9d682d);box-shadow:inset 0 1px rgba(255,255,255,.22)}.agreeart .no,.warningart .no{border:1px solid #664047;background:#271116;color:#cdbbb0}.closeart{position:absolute;right:14px;top:14px;width:32px;height:32px;padding:0;border:0;background:transparent;opacity:.7}.closeart:hover{opacity:1}.closeart img{width:14px;height:14px;margin:0;filter:sepia(1) brightness(1.4)}
</style>
<style scoped>
.loginmodal{background:rgba(0,0,0,.88)!important}.art{border-color:#5b1723;border-radius:0;background:#0b0b0d;box-shadow:0 24px 80px rgba(0,0,0,.78)}.art p{color:#e8e8ea}.art .img{filter:grayscale(1) sepia(.35) hue-rotate(300deg) saturate(2.5) brightness(1.6)}.agreeart .yes,.warningart .yes{border-color:#d31c3b;border-radius:0;color:#fff;background:#9f1028}.agreeart .no,.warningart .no{border-color:#3b3b40;border-radius:0;background:#151517;color:#bbbcc1}.closeart img{filter:grayscale(1) brightness(1.9)}
</style>
<style scoped src="@/styles/header.css"></style>
<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/subcommon.css"></style>
<style scoped>
.loginmodal{background:rgba(0,0,0,.9)!important;backdrop-filter:blur(9px)}.art{width:410px;padding:34px 38px 32px;border:1px solid #4f2029;border-radius:0;background:linear-gradient(145deg,#1d0a0e,#09090b 70%);box-shadow:0 32px 100px rgba(0,0,0,.82),inset 0 1px rgba(255,255,255,.04)}.art:before{content:"";position:absolute;left:34px;right:34px;top:0;height:2px;background:linear-gradient(90deg,transparent,#c11d3a,transparent)}.alert-kicker{display:block;margin-bottom:20px;color:#c82542;font-size:9px;font-weight:800;letter-spacing:.3em}.art .img{width:46px;height:46px;padding:9px;box-sizing:border-box;border:1px solid #63303a;border-radius:50%;background-size:25px!important;background-color:#180b0e!important;filter:grayscale(1) sepia(.45) hue-rotate(300deg) saturate(3) brightness(1.8)}.art p{margin-top:18px;color:#ededee;font-size:14px;font-weight:500;line-height:1.7}.art .yes,.art .no{height:45px;margin-top:26px;border-radius:0;font-size:12px;letter-spacing:.06em}.agreeart .yes,.warningart .yes{border:1px solid #d12845;color:#fff;background:linear-gradient(135deg,#b41834,#781020);box-shadow:0 9px 22px rgba(139,14,36,.25)}.agreeart .yes:hover,.warningart .yes:hover{background:linear-gradient(135deg,#cf2947,#91142a)}.agreeart .no,.warningart .no{border:1px solid #404045;background:#121214;color:#c6c6ca}.closeart{right:12px;top:12px;border:1px solid transparent}.closeart:hover{border-color:#3c3c40;background:#151517}.closeart img{filter:grayscale(1) brightness(2)}
</style>
